import React, { Component } from 'react';
import Slide from '../Globals/Slide/slide';
import Asignacion from './asignacionViajes';
import Disponibilidad from './disponibilidad';
import CancelarViajes from './cancelarViajes';
import Unidades from './unidades';
import taxi from '../../img/taxiW.png';
import unidDisp from '../../img/auto.png';
import asigViaj from '../../img/checkW.png';
import ubicViaj from '../../img/ubicacion.png';
import './estilo.css';
import store from '../../store';

class PlaniViajes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: localStorage.getItem('activeTab') || 'unidades'
        };
        this.ocultarMenu = this.ocultarMenu.bind(this);
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    ocultarMenu() {
        store.dispatch({
            type: 'STATE_MOSTRAR',
            mostrar: 'noMostrar'
        });
    }

    handleTabClick(tab) {
        this.setState({ activeTab: tab });
        localStorage.setItem('activeTab', tab);
    }

    render() {
        const { activeTab } = this.state;

        return (
            <div onClick={this.ocultarMenu}>
                <div className="container mt-4">
                    <div className="row">
                        <div className="col-1">
                            <img src={taxi} alt="Taxi" />
                        </div>
                        <div className="col-11">
                            <h3 className="title-blue">Coordinación de unidades</h3>
                            <span className="text-info">Visualización de unidades y asignación de viajes</span>
                        </div>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-12">
                            <ul className="nav nav-tabs m-bottom flex-column flex-md-row justify-content-end" role="tablist">
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === 'unidades' ? 'active show' : ''}`}
                                        id="unidades-tab"
                                        data-toggle="tab"
                                        href="#unidades"
                                        role="tab"
                                        aria-controls="unidades"
                                        aria-selected={activeTab === 'unidades'}
                                        onClick={() => this.handleTabClick('unidades')}
                                    >
                                        <img src={unidDisp} alt="Unidades Disponibles" />&nbsp;&nbsp;&nbsp;Unidades disponibles
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === 'asignacion' ? 'active show' : ''}`}
                                        id="asignacion-tab"
                                        data-toggle="tab"
                                        href="#asignacion"
                                        role="tab"
                                        aria-controls="asignacion"
                                        aria-selected={activeTab === 'asignacion'}
                                        onClick={() => this.handleTabClick('asignacion')}
                                    >
                                        <img src={asigViaj} alt="Asignación de Viajes" />&nbsp;&nbsp;&nbsp;Asignación de viajes
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === 'estatus' ? 'active show' : ''}`}
                                        id="estatus-tab"
                                        data-toggle="tab"
                                        href="#estatus"
                                        role="tab"
                                        aria-controls="estatus"
                                        aria-selected={activeTab === 'estatus'}
                                        onClick={() => this.handleTabClick('estatus')}
                                    >
                                        <img src={ubicViaj} alt="Estatus de Viajes" />&nbsp;&nbsp;&nbsp;Estatus de viajes
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === 'cancelar' ? 'active show' : ''}`}
                                        id="cancelar-tab"
                                        data-toggle="tab"
                                        href="#cancelar"
                                        role="tab"
                                        aria-controls="cancelar"
                                        aria-selected={activeTab === 'cancelar'}
                                        onClick={() => this.handleTabClick('cancelar')}
                                    >
                                        <i className="fa fa-times" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Cancelación de viajes
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        <div className={`tab-pane fade ${activeTab === 'unidades' ? 'active show' : ''}`} id="unidades" role="tabpanel" aria-labelledby="unidades-tab">
                            <Unidades
                                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M&v=3.exp&libraries=geometry,drawing,places"
                                loadingElement={<div style={{ height: '600px' }} />}
                                containerElement={<div />}
                                mapElement={<div style={{ height: '500px', width: '45rem' }} />}
                            />
                        </div>

                        <div className={`tab-pane fade ${activeTab === 'asignacion' ? 'active show' : ''}`} id="asignacion" role="tabpanel" aria-labelledby="asignacion-tab">
                            <Asignacion />
                        </div>

                        <div className={`tab-pane fade ${activeTab === 'estatus' ? 'active show' : ''}`} id="estatus" role="tabpanel" aria-labelledby="estatus-tab">
                            <Disponibilidad />
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'cancelar' ? 'active show' : ''}`} id="cancelar" role="tabpanel" aria-labelledby="cancelar-tab">
                            <CancelarViajes />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PlaniViajes;


// WEBPACK FOOTER //
// ./src/Components/Planificacion/planiViajes.js